import type { AxiosResponse } from 'axios'
import type { IServerResponse } from '@/models/IServerResponse'
import { ITagReferentiel } from '@/models/ITagReferentiel'
import axios from '@/plugins/axios'

const resource = 'api/v1/tags_referentiel'

export default {
    getFollowUpFilterTagsReferentielForClient(): Promise<AxiosResponse<IServerResponse<Array<ITagReferentiel>>>> {
        return axios.get(`${resource}/follow_up/client`)
    },
}
